<template>
  <EditableBoard
    :value="value"
    @input="$ev => $emit('input', $ev)"
    :columns="column"
    :create-label="$t('add')"
    :custom-add="add"
    class="quick-notes-editor"
    add-fields
  >
    <template #icon="{ item }">
      <Webcomponent
        v-model="item.icon"
        tag="kvass-icon-selector"
        default-search=""
        source="https://cdn.jsdelivr.net/npm/@kvass/widgets@latest/dist/icon-selector.js"
      />
    </template>

    <template #label="{ item }">
      <InputComponent v-model="item.label" :placeholder="$t('quicknotesLabelPlaceholder')" required />
    </template>

    <template #color="{ item }">
      <ColorSelector v-model="item.color" />
    </template>

    <template #actions="{ item, close }">
      <DropdownComponent :close-on-click="false">
        <template #default>
          <ButtonComponent icon="fa-pro-light:ellipsis-vertical" />
        </template>
        <template #dropdown="{ close }">
          <ButtonComponent :label="$t('remove')" icon="fa-pro-light:trash" confirm @click="() => remove(item, close)" />
        </template>
      </DropdownComponent>
    </template>
  </EditableBoard>
</template>

<script>
import EditableBoard from '@/components/EditableBoard.vue'
import { InputComponent } from 'vue-elder-input'
import { DropdownComponent } from 'vue-elder-dropdown'
import ColorSelector from '@kvass/custom-fields/src/Fields/ColorSelector'
import Webcomponent from '@kvass/custom-fields/src/Fields/Webcomponent'

const Template = {
  icon: 'fa-pro-light:plus-circle',
  label: '',
  color: '#4a90e2',
}

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    column() {
      return [
        { id: 'icon', label: this.$tc('icon', 1), size: '70px' },
        { id: 'color', label: this.$t('color'), size: '60px' },
        { id: 'label', label: this.$tc('message', 1), size: '1fr' },
        { id: 'actions', label: '', size: '40px' },
      ]
    },
  },
  methods: {
    add() {
      this.$emit('input', [...this.value, structuredClone(Template)])
    },
    remove(item, close) {
      this.$emit(
        'input',
        this.value.filter(v => v !== item),
      )
      close()
    },
  },
  components: {
    EditableBoard,
    InputComponent,
    ColorSelector,
    Webcomponent,
    DropdownComponent,
  },
}
</script>

<style lang="scss">
.quick-notes-editor {
  --kvass-icon-selector-trigger-padding-y: 0.75em;
  --kvass-icon-selector-trigger-padding-x: 0.8em;

  .editable-board__cell input {
    padding: 0.7em 0.8em;
  }

  .elder-input__field:has(input[type='color']) label {
    display: none;
  }

  .elder-dropdown {
    font-size: 0.8em;
  }

  input[type='color'] {
    height: 45px !important;
    padding: 0.3em 0.8em;
  }
}
</style>
